const config = {
  //backendUrl: "http://localhost:3001/api",
  backendUrl: "https://backend.handpik.ai/api",
  agentBackendUrl: "http://localhost:8000",
  googleClientId: "763852294287-4r9s4dcfetm9gphruuulmacnpbt4ptve.apps.googleusercontent.com"
};

export default config;
